"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config = {
    mediaBreakpoints: {
        values: {
            desktopMinWidth: '1025px',
            tabletMinWidth: '481px',
            tabletMaxWidth: '1024px',
            mobileMaxWidth: '480px',
        },
    },
    regExp: {
        eMail: {
            checkAt: new RegExp(/\b[\w.-]+@[\w.-]*\b/),
            checkProvider: new RegExp(/\b[\w.-]+@[\w.-]+\.\w{2,}\b/),
        },
    },
    apiAgnitasUrl: {
        environmentRelated: true,
        values: {
            url: "https://agnitas-service.platform.empirie." + (process.env.NODE_ENV === 'production' ? 'cloud' : 'dev') + "/" + process.env.FRAGMENT_COMPANYID + "/v0",
        },
    },
};
exports.default = config;
//# sourceMappingURL=default.js.map